/**
 * Detail model
 *
 * @class Model_Detail
 * @extends Model
 */

Model_Detail = (function (Model) {

	var Model_Detail = function () {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Model_Detail.prototype, Model.prototype, {

		/**
		 * Initialize Model_Detail
		 */
		init: function () {
			/**
			 * @property {Boolean} fetched - flag for fetching full asset detail and related assets.
			 * NOTE: it's set by Model_Detail.fetchFullDetail
			 */
			this.fetched = false;

		},

		/**
		 * @returns {String} Model id
		 */
		getId: function () {
			return (this.data && this.data.id) ? this.data.id : false;
		},

		/**
		 * @returns {Boolean} return value tells if full asset detail and related assets were fetched
		 */
		isFetched: function () {
			return this.fetched;
		},

		/**
		 * @returns {String} Background image url
		 */
		getBackgroundUrl: function() {
			return this.get('thumb_smarttv_url');
		},

		/**
		 * @returns {Object} With title, metadata and description texts
		 */
		getTexts: function() {
			releaseDate = this.get('created_at') ? this.get('created_at') : '';
			duration = (parseInt(this.get('duration'))/60).toFixed(0);
			metadata = releaseDate.substr(0, 4) ? "( " + releaseDate.substr(0, 4) + " ) " : ''  + duration ? duration + " " + __('min') : '';
			var texts = {
				title: this.get('name') ? this.get('name') : '',
				metadata: metadata,
				description: this.get('description') ? this.get('description') : '',
			};
			return texts;
		},

		getVideosArray: function() {
            var videoToArray = [];
            videoToArray.push(this);
			return videoToArray;
		},

		getLongDescription: function() {
			return this.get('description')
		},

		getCastObject: function() {
			var castObject = {};
			return castObject;
		},

		/**
		 * @returns {String} Movie title
		 */
		getTitle: function () {
			return this.get('name');
		},
	});

	return Model_Detail;

})(Model);



//////////////////
// WEBPACK FOOTER
// ./js/model/detail.js
// module id = 47
// module chunks = 0